import axiosInstance from "./axiosInstance";
import EntitiesResponse from "../types/EntitiesResponse";

export const fetchRoles = async (): Promise<EntitiesResponse | void> => {
    return axiosInstance.get<EntitiesResponse>("/roles")
        .then(response => response.data)
        .catch(error => error.response.data)
}